export default "__VITE_PUBLIC_ASSET__9a3323a0__"